import React from 'react'
import { isValidEmail } from '@ztechapps/common.utils'
import { Field, Form } from '@ztechapps/webui.form'
import { TextInput } from '@ztechapps/webui.input'
import { ForgotPasswordButton } from './ForgotPasswordButton'
import { useFetch, useRecaptcha } from '@ztechapps/common.hook'

export type ForgotPasswordProps = {
  after?: (e?: any) => void
  url: string
  recaptchaSiteKey: string
}

export type ForgotPasswordFormValues = {
  username: string
}

export const ForgotPassword = ({ after, url, recaptchaSiteKey }: ForgotPasswordProps) => {
  const [fetchNow] = useFetch(url)

  const { getTokenOrThrow } = useRecaptcha({ recaptchaSiteKey })

  const handleSubmitForm = async ({ username }, formikBag) => {
    const recaptchaToken = await getTokenOrThrow()

    const { error } = await fetchNow({ username, recaptchaToken })

    if (error) {
      formikBag.setFieldError('username', error?.message ?? error ?? 'Server error occurred')
      throw error
    }

    after?.()
  }

  const validate = (values: ForgotPasswordFormValues) => {
    const errors = {} as ForgotPasswordFormValues

    if (!values.username) errors.username = 'Required.'

    if (!isValidEmail(values.username)) errors.username = 'You enter invalid email format.'

    return errors
  }

  return (
    <Form initialValues={{ username: '' }} onSubmit={handleSubmitForm} validate={validate}>
      <div className="mb-2">
        <Field name="username" type="email" label="Email" required minLength={6} component={TextInput} />
      </div>

      <ForgotPasswordButton />
    </Form>
  )
}
